module.exports = __webpack_public_path__ + "static/media/6TunasDouro4.4edd1b60.jpg";